import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from 'vue';

import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';
import {
  NavBar,
  HelperViewStatus,
  Heading,
  BaseText,
  InitialAvatarIcon,
  ProgressBar,
  BaseIcon
} from '@warrenbrasil/nebraska-web';
import { BackButton } from '@/modules/common/components/buttons';
import { FeesDetails } from './components';

import {
  IOrderItem,
  EOrderStatus,
  IFeesDetails
} from '@/modules/wealth/services/portfolio-orders';

interface Props {
  orderItem: IOrderItem;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'OrderDetailsHero',
  props: {
    orderItem: null
  },
  setup(__props: any) {

const props = __props as {
  orderItem: IOrderItem;
};



const isFeesDetailsOpen = ref(false);
const feesDetails = ref<IFeesDetails[]>([]);

const isCanceled = computed(() => {
  return orderHeader.value.status === EOrderStatus.CANCELED;
});

const orderHeader = computed(() => {
  return props.orderItem.details.header;
});

const videoSourceByStatus = computed(() => {
  const statusMapper: { [key: string]: string } = {
    [EOrderStatus.FINISHED]: require('@/assets/videos/green-bg-animated.webm'),
    [EOrderStatus.PROCESSING]: require('@/assets/videos/blue-bg-animated.webm')
  };

  return statusMapper[orderHeader.value.status];
});

function openFeesDetails(fees: IFeesDetails[]) {
  feesDetails.value = fees;
  isFeesDetailsOpen.value = true;
}

return { __sfc: true,props, isFeesDetailsOpen, feesDetails, isCanceled, orderHeader, videoSourceByStatus, openFeesDetails, NebraskaColors, NavBar, HelperViewStatus, Heading, BaseText, InitialAvatarIcon, ProgressBar, BaseIcon, BackButton, FeesDetails }
}

})